<template>
    <div :class="['item', 'item--'+item.type]">
        <div class="main">
            <div class="top">
                <div class="row align-center">
                    <div class="label">{{labels[item.type]}}</div>
                    <div class="date mobile">
                        <span class="time">{{ item.datetime | timestampTime(true) }}</span>
                        {{ item.datetime | timestampFullDate(false, true) }}
                    </div>
                    <div
                        class="avatar"
                        v-if="item.type === 'meeting'"
                        :style="item.initiatorAvatar ? { backgroundImage: `url(${item.initiatorAvatar})`} : {}"
                    ></div>
                </div>
                <div class="date">
                    <span class="time">{{ item.datetime | timestampTime(true) }}</span>
                    {{ item.datetime | timestampFullDate(false, true) }}
                </div>

                <div class="theme">{{ item.theme | ellipsis(65) }}</div>
                <div class="confirmation" v-if="role === 'student' && item.status === 'confirmation'">
                    <div class="tag">Статус:</div>
                    На рассмотрении
                </div>
                <div class="location" v-if="item.location">
                    <div class="tag">Место:</div>
                    {{ item.location }}
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="action_btn"
                 v-if="item.location"
                 @click="openMap(item)"
            >
                <font-awesome-icon icon="map-marker-alt" />
                Показать на карте
            </div>
            <a
                class="action_btn"
                v-if="item.link"
                :href="item.link"
                target="_blank"
            >
                <font-awesome-icon icon="globe" />
                Перейти по ссылке
            </a>
            <div
                class="show-details"
                @click="$emit('click', 'details')"
            >Подробнее</div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'DefaultActivityCard',
    data: () => ({
        labels: {
            webinar: 'Вебинар',
            session: 'Сессия',
            course: 'Курс',
            meeting: 'Встреча',
        },
    }),
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    methods: {
        openMap(item) {
            window.open('https://yandex.com/maps/?text='+item.location, '_blank');
        },
    },
    computed: {
        ...mapState('mentoring', [
            'role',
        ]),
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';

    @include on-desktop {
        .date.mobile {
            display: none;
        }
    }

    @include on-mobile {
        .date {
            display: none;
            &.mobile {
                display: block;
                margin-bottom: 0;
                margin-left: mrem(8);
                margin-right: mrem(39);
                width: auto;
            }
        }
    }
</style>
